export const environmentConfig = {
    quizIncGameHost: `http://mycontent.mobi/optin/service/4069?bc_id=63`,
    quizIncApi: "https://api.quizinc.co.za",
    dataDecryptionHost: "https://utils.vodacomfantasy.com/userDataDecryption",
    utilsService: "https://utils.vodacomfantasy.com/utils",
    quizIncServiceId: `vc-fanclash-quizinc-01`
}
